module.exports = __webpack_public_path__ + "static/shuttleid-partnership-cf570a123135c422f62026ca360b9313.jpg";